import { Link, useLocation } from 'react-router-dom';
import { communesData } from '../../mocks/communes';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const location = useLocation();
  
  // Déterminer le texte de localisation en fonction de l'URL
  let locationText = "Paris & Île-de-France";
  
  // Extraire le slug de la commune depuis l'URL (format: /commune/vanves)
  const pathParts = location.pathname.split('/').filter(Boolean);
  
  if (pathParts.length >= 2 && pathParts[0] === 'commune') {
    const communeSlug = pathParts[1];
    const communeData = communesData[communeSlug];
    
    if (communeData && communeData.name) {
      locationText = communeData.name;
    }
  }

  return (
    <footer className="bg-navy text-white">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand Column */}
          <div className="lg:col-span-1">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 bg-white rounded-xl flex items-center justify-center">
                <i className="ri-drop-fill text-2xl text-navy"></i>
              </div>
              <span className="font-montserrat font-bold text-xl block">A et F Services</span>
            </div>
            <p className="font-inter text-sm text-white/70 leading-relaxed mb-6">
              Votre expert en plomberie et chauffage depuis 2019. Service professionnel, rapide et disponible 24h/24 en Île-de-France.
            </p>
            <div className="flex items-center gap-3">
              <div className="w-8 h-5 rounded overflow-hidden flex">
                <div className="w-1/3 bg-french-blue"></div>
                <div className="w-1/3 bg-white"></div>
                <div className="w-1/3 bg-french-red"></div>
              </div>
              <span className="font-inter text-xs text-white/50">Entreprise française</span>
            </div>
          </div>

          {/* Navigation */}
          <div>
            <h3 className="font-montserrat font-semibold text-base mb-6">Navigation</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="font-inter text-sm text-white/70 hover:text-white transition-colors cursor-pointer">
                  Accueil
                </Link>
              </li>
              <li>
                <Link to="/services" className="font-inter text-sm text-white/70 hover:text-white transition-colors cursor-pointer">
                  Nos Services
                </Link>
              </li>
              <li>
                <Link to="/mentions-legales" className="font-inter text-sm text-white/70 hover:text-white transition-colors cursor-pointer">
                  Mentions Légales
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="font-montserrat font-semibold text-base mb-6">Nos Services</h3>
            <ul className="space-y-3 font-inter text-sm text-white/70">
              <li className="flex items-center gap-2">
                <i className="ri-checkbox-circle-fill text-accent text-xs"></i>
                Dépannage urgent 24h/24
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-checkbox-circle-fill text-accent text-xs"></i>
                Installation sanitaire
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-checkbox-circle-fill text-accent text-xs"></i>
                Rénovation salle de bain
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-checkbox-circle-fill text-accent text-xs"></i>
                Débouchage canalisations
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-checkbox-circle-fill text-accent text-xs"></i>
                Détection de fuites
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="font-montserrat font-semibold text-base mb-6">Contact</h3>
            <ul className="space-y-4">
              <li>
                <a 
                  href="tel:0756848431" 
                  className="font-inter text-sm text-white/70 hover:text-white transition-colors flex items-center gap-3 cursor-pointer"
                >
                  <div className="w-10 h-10 flex items-center justify-center bg-white/10 rounded-lg">
                    <i className="ri-phone-fill text-accent"></i>
                  </div>
                  <div>
                    <span className="block text-white font-medium">07 56 84 84 31</span>
                    <span className="text-xs text-white/50">Disponible 24h/24</span>
                  </div>
                </a>
              </li>
              <li>
                <a 
                  href="mailto:contact@mercier-plomberie.fr" 
                  className="font-inter text-sm text-white/70 hover:text-white transition-colors flex items-center gap-3 cursor-pointer"
                >
                  <div className="w-10 h-10 flex items-center justify-center bg-white/10 rounded-lg">
                    <i className="ri-mail-fill text-accent"></i>
                  </div>
                  <div>
                    <span className="block text-white font-medium">contact@mercier-plomberie.fr</span>
                    <span className="text-xs text-white/50">Réponse sous 24h</span>
                  </div>
                </a>
              </li>
              <li className="flex items-center gap-3">
                <div className="w-10 h-10 flex items-center justify-center bg-white/10 rounded-lg">
                  <i className="ri-map-pin-fill text-accent"></i>
                </div>
                <div className="font-inter text-sm">
                  <span className="block text-white font-medium">{locationText}</span>
                  <span className="text-xs text-white/50">Intervention rapide</span>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row justify-center items-center gap-4">
            <p className="font-inter text-sm text-white/50">
              © {currentYear} A et F Services. Tous droits réservés.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
